import cx from 'classnames'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../Buttons/ButtonCinestar/ButtonCinestar'
import Checkbox from '../../../../Inputs/Checkbox/Checkbox'
import InputDate from '../../../../Inputs/InputDate/InputDate'
import InputText from '../../../../Inputs/InputText/InputText'
import Radio from '../../../../Inputs/Radio/Radio'
import RadioGroup from '../../../../Inputs/RadioGroup/RadioGroup'
import Typography from '../../../../Typography/Typography'
import FormInputsContainer from '../../../FormInputsContainer/FormInputsContainer'

import { documentSlugs } from 'components/Modal/DocumentPopupWindow/slugs'
import './MemberInputs.scss'

const MemberInputs = ({ className, loading, setWithMemberAccount, formik, setSlug }) => {
    const intl = useIntl()

    const handleSubmit = () => {
        setWithMemberAccount(true)
    }

    return (
        <div className={cx('member-inputs d-flex flex-column', className)}>
            <Typography variant={'h3'}>
                {intl.formatMessage({ id: 'forms.register.cinestarClubMember.title' })}
            </Typography>
            <RadioGroup
                id={'gender'}
                label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.gender' })}
                error={formik?.errors?.gender}
                touched={formik?.touched?.gender}
                {...formik.getFieldProps('gender')}
            >
                <Radio
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.man' })}
                    value="Male"
                    name={'gender'}
                    error={formik?.errors?.gender}
                    touched={formik?.touched?.gender}
                    color={'purple'}
                />
                <Radio
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.woman' })}
                    value="Female"
                    name={'gender'}
                    error={formik?.errors?.gender}
                    touched={formik?.touched?.gender}
                    color={'purple'}
                />
                <Radio
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.other' })}
                    value="NonBinary"
                    name={'gender'}
                    error={formik?.errors?.gender}
                    touched={formik?.touched?.gender}
                    color={'purple'}
                />
            </RadioGroup>

            <FormInputsContainer>
                <InputDate
                    color={'purple'}
                    name={'date'}
                    error={formik?.errors?.date}
                    touched={formik?.touched?.date}
                    value={formik?.values?.date}
                    onHandle={(date) => {
                        formik.setFieldValue('date', date)
                    }}
                    onBlur={formik?.handleBlur}
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.dateLabel' })}
                    placeholder={intl.formatMessage({
                        id: 'forms.register.cinestarClubMember.datePlaceholder',
                    })}
                />
                <div className="d-none d-md-block w-100" />
            </FormInputsContainer>

            <FormInputsContainer>
                <InputText
                    color={'purple'}
                    name={'residance'}
                    id={'residance'}
                    error={formik?.errors?.residance}
                    touched={formik?.touched?.residance}
                    {...formik.getFieldProps('residance')}
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.residenceLabel' })}
                    placeholder={intl.formatMessage({
                        id: 'forms.register.cinestarClubMember.residencePlaceholder',
                    })}
                    onBlur={formik?.handleBlur}
                />
                <InputText
                    color={'purple'}
                    type={'number'}
                    name={'postalCode'}
                    id={'postalCode'}
                    error={formik?.errors?.postalCode}
                    touched={formik?.touched?.postalCode}
                    {...formik.getFieldProps('postalCode')}
                    label={intl.formatMessage({ id: 'forms.register.cinestarClubMember.postalCodeLabel' })}
                    placeholder={intl.formatMessage({
                        id: 'forms.register.cinestarClubMember.postalCodePlaceholder',
                    })}
                    onBlur={formik?.handleBlur}
                />
            </FormInputsContainer>

            <Container fluid>
                <Typography variant={'h3'} className={'mb-2'}>
                    {intl.formatMessage({ id: 'forms.register.cinestarClubMember.agreement.title' })}
                </Typography>
            </Container>

            <Checkbox
                color={'purple'}
                name={'checkBoxMember'}
                id={'checkBoxMember'}
                error={formik?.errors?.checkBoxMember}
                touched={formik?.touched?.checkBoxMember}
                {...formik.getFieldProps('checkBoxMember')}
                label={intl.formatMessage(
                    { id: 'forms.register.cinestarClubMember.agreement.checkboxLabel' },
                    {
                        link: (chunks) => (
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.addsNews })}
                                className="text-decoration-underline"
                            >
                                {chunks}
                            </a>
                        ),
                    }
                )}
                onBlur={formik?.handleBlur}
            />

            <Checkbox
                color={'purple'}
                name={'checkBoxRead'}
                id={'checkBoxRead'}
                error={formik?.errors?.checkBoxRead}
                touched={formik?.touched?.checkBoxRead}
                {...formik.getFieldProps('checkBoxRead')}
                label={intl.formatMessage(
                    { id: 'forms.register.cinestarClubMember.agreement.description' },
                    {
                        memberLink: (chunks) => (
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.loyaltyProgram })}
                                className="text-decoration-underline"
                            >
                                {chunks}
                            </a>
                        ),
                        conditions: (chunks) => (
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.conditions })}
                                className="text-decoration-underline"
                            >
                                {chunks}
                            </a>
                        ),
                        personalData: (chunks) => (
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.personalData })}
                                className="text-decoration-underline"
                            >
                                {chunks}
                            </a>
                        ),
                    }
                )}
                onBlur={formik?.handleBlur}
            />

            <Typography variant={'tableText'}>
                {intl.formatMessage({ id: 'forms.register.cinestarClubMember.agreement.description2' })}
            </Typography>

            <FormInputsContainer>
                <ButtonCinestar
                    variant={'primary-v1'}
                    type={'submit'}
                    name="submit-form"
                    disabled={loading}
                    onClick={() => handleSubmit()}
                >
                    {intl.formatMessage({ id: 'forms.register.cinestarClubMember.buttonBecomeMember' })}
                </ButtonCinestar>
            </FormInputsContainer>
        </div>
    )
}

export default MemberInputs
